
export default function About() {
  return (
    <section id="nosotros" className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
          {/* Left Column - Content */}
          <div>
            <div className="inline-block px-4 sm:px-6 py-2 border-2 border-[#1e3a8a] rounded-full mb-6 sm:mb-8">
              <span className="text-[#1e3a8a] text-xs sm:text-sm font-semibold">Sobre Nosotros</span>
            </div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#1e3a8a] mb-6 sm:mb-8 leading-tight">
              Expertos en Fontanería Profesional
            </h2>

            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-8 sm:mb-12">
              Con más de 25 años de experiencia, somos líderes en servicios de fontanería profesional. 
              Nuestro equipo de expertos certificados está comprometido con la excelencia, ofreciendo 
              soluciones rápidas y duraderas para hogares y negocios. Cada proyecto es una oportunidad 
              para demostrar nuestra dedicación a la calidad y satisfacción del cliente.
            </p>

            {/* Statistics */}
            <div className="grid grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
              <div>
                <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#3B82F6] mb-1 sm:mb-2">5000+</div>
                <div className="text-xs sm:text-sm text-gray-600 leading-tight">Clientes Satisfechos</div>
              </div>
              <div>
                <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#3B82F6] mb-1 sm:mb-2">25</div>
                <div className="text-xs sm:text-sm text-gray-600 leading-tight">Años de Experiencia</div>
              </div>
              <div>
                <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#3B82F6] mb-1 sm:mb-2">100%</div>
                <div className="text-xs sm:text-sm text-gray-600 leading-tight">Garantía de Servicio</div>
              </div>
            </div>
          </div>

          {/* Right Column - Images */}
          <div className="relative">
            <div className="space-y-4 sm:space-y-6">
              {/* Top Image */}
              <div className="w-full h-64 sm:h-72 lg:h-80 rounded-2xl sm:rounded-3xl overflow-hidden shadow-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20plumbing%20installation%20modern%20copper%20pipes%20premium%20quality%20materials%20clean%20organized%20workspace%20technical%20precision%20high-end%20plumbing%20system%20elegant%20design%20professional%20craftsmanship%20simple%20clean%20background&width=800&height=500&seq=about-pipes-professional-002&orientation=landscape"
                  alt="Instalación Profesional"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Bottom Image */}
              <div className="w-4/5 h-48 sm:h-52 lg:h-56 rounded-2xl sm:rounded-3xl overflow-hidden shadow-xl ml-auto">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20plumbing%20tools%20equipment%20organized%20toolbox%20quality%20instruments%20modern%20tools%20clean%20display%20technical%20equipment%20professional%20grade%20tools&width=700&height=400&seq=about-tools-001&orientation=landscape"
                  alt="Herramientas Profesionales"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Floating Badge */}
            <div className="absolute top-1/2 left-0 transform -translate-y-1/2 -translate-x-4 sm:-translate-x-6 lg:-translate-x-8 w-24 h-24 sm:w-28 sm:h-28 lg:w-32 lg:h-32 bg-[#3B82F6] rounded-full flex flex-col items-center justify-center shadow-2xl">
              <div className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 flex items-center justify-center mb-1">
                <i className="ri-verified-badge-line text-white text-2xl sm:text-3xl"></i>
              </div>
              <span className="text-white text-xs sm:text-sm font-bold text-center px-2">Certificados</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
